import {useContext, useState } from "react";
import Img from "../img/ImgLogin.jpg";
import logo from "../img/logo.jpeg";
import {useForm} from 'react-hook-form'
import {petitions} from '../api/calls.js'
import { toast } from 'sonner'
import {useNavigate } from 'react-router-dom';
import {DataContext} from '../context/DataContext.jsx'

export default function Login() {
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();
  
  const {saveUser, saveEmpresa} = useContext(DataContext)

  const {register,handleSubmit, formState: {errors}} = useForm();

  const onSubmit = handleSubmit(async (data) => {
    const loginPromise = petitions.login(data.user.trim(), data.pass.trim());

    toast.promise(loginPromise, {
      loading: 'Iniciando sesión...',
      success: (response) => {
        if (response.status === "success") {
          // GUARDAR EN CACHE
          localStorage.setItem("session", JSON.stringify({
            idUsuario: response.data.idUsuario,
            token: response.data.token
          }));

          // GUARDAR ESTADO DEL USUARIO
          saveUser(response.data.idUsuario, response.data.token);

          const empresa = localStorage.getItem("empresa");
          if (empresa) {
            const idEmpresa = JSON.parse(empresa).value;
            saveEmpresa(idEmpresa, response.data.token);
            navigate('main', { replace: true });
          } else {
            navigate('SelectCompany', { replace: true });
          }

          return "Sesión iniciada correctamente ✅";
        } else {
          // Lanzamos error para que entre en el catch de toast.promise
          throw new Error(
            typeof response.code === "string" ? response.message : response.data
          );
        }
      },
      error: (err) => {
        return err.message || "Error al iniciar sesión ❌";
      },
    });
  });

  
  return (
      <main className="main" id="top">
        <div className="row vh-100 g-0">
          <div className="col-lg-6 position-relative d-none d-lg-block">
            <div
              className="bg-holder"
              style={{ backgroundImage: `url(${Img})` }}
            ></div>
          </div>
          <div className="col-lg-6">
            <div className="row flex-center h-100 g-0 px-4 px-sm-0">
              <div className="col col-sm-6 col-lg-7 col-xl-6">
                <a
                  className="d-flex flex-center text-decoration-none mb-4"
                  href="../../../index.html"
                >
                  <div className="d-flex align-items-center fw-bolder fs-3 d-inline-block">
                    <img src={logo} alt="phoenix" width="70" className="rounded-5"/>
                  </div>
                </a>
                <div className="text-center mb-4">
                  <h3 className="text-body-highlight">Login</h3>
                  <p className="text-body-tertiary">
                    Obtenga acceso a su cuenta con
                  </p>
                </div>
                <button className="btn btn-phoenix-secondary w-100 mb-3 rounded-4" onClick={() => {toast.error("Funcionalidad no disponible")}}>
                  <span className="fab fa-google text-danger me-2 fs-9"></span>
                  Continuar con google
                </button>
                <button className="btn btn-phoenix-secondary w-100 rounded-4" onClick={() => {toast.error("Funcionalidad no disponible")}}>
                  <span className="fab fa-facebook text-primary me-2 fs-9"></span>Continuar con facebook
                </button>
                <div className="position-relative">
                  <hr className="bg-body-secondary mt-5 mb-4" />
                  <div className="divider-content-center">
                    O ingrese sus creedenciales
                  </div>
                </div>
                <form onSubmit = {onSubmit}>
                  <div className="mb-3 text-start">
                    <label className="form-label" htmlFor="email">
                      Usuario
                    </label>
                    <div className="form-icon-container">
                      <input
                        className="form-control form-icon-input rounded-4 border-0 shadow-sm"
                        type="text"
                        placeholder="demo"
                        {...register("user",{
                          required: {
                            value: true,
                            message: "Ingrese el usuario"
                          },
                          minLength: {
                            value: 2,
                            message: "El usuario debe tener mas de 2 caracteres"
                          },
                          maxLength: {
                            value: 20,
                            message: "Usuario muy largo"
                          },
                          pattern: { value: /^[a-zA-Z0-9]+$/, message: "Solo se permiten letras y números" }
                        })}
                      />
                      <span className="fas fa-user text-body fs-9 form-icon"></span>
                    </div>
                    { errors?.user && <code>{errors.user.message}</code> } 
                  </div>
                  <div className="mb-3 text-start">
                    <label className="form-label" htmlFor="password">
                      Contraseña
                    </label>
                    <div className="form-icon-container">
                      <input
                        className="form-control form-icon-input rounded-4 border-0 shadow-sm"
                        type="password"
                        placeholder="demo"
                        {...register("pass",{
                          required: {
                            value: true,
                            message: "Ingrese la contraseña"
                          },
                          minLength: {
                            value: 2,
                            message: "La contraseña debe tener mas de 2 caracteres"
                          },
                          maxLength: {
                            value: 30,
                            message: "Contraseña muy larga"
                          },
                          pattern: { value: /^[a-zA-Z0-9]+$/, message: "Solo se permiten letras y números" }
                        })}
                      />
                      <span className="fas fa-key text-body fs-9 form-icon"></span>
                    </div>
                    { errors?.pass && <code>{errors.pass.message}</code> } 
                  </div>
                  <div className="row flex-between-center mb-7">
                    <div className="col-auto">
                      <div className="form-check mb-0">
                        <input
                          className="form-check-input"
                          id="basic-checkbox"
                          type="checkbox"
                          value={isChecked}
                          onChange={(event) => setIsChecked(event.target.value)}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="basic-checkbox"
                        >
                          Acuérdate de mí
                        </label>
                      </div>
                    </div>
                    <div className="col-auto">
                      <a
                        className="fs-9 fw-semibold"
                        onClick={()=>{toast.warning("Funcionalidad aun no disponible")}}
                      >
                        ¿Has olvidado tu contraseña?
                      </a>
                    </div>
                  </div>
                  <button className="btn btn-primary w-100 mb-3 rounded-4" type="submit">
                    Iniciar sesión
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>    
  );
}


